import { useSelector } from 'react-redux';
import { selectCurrentTenant } from 'reducers/selectors';

const CopyRight = ({ style = {} }) => {
  const { tenantData } = useSelector(selectCurrentTenant);

  return (
    <div style={{ ...style, color: 'var(--user-main-text)' }} className="bottom-wrap">
      <div style={{ textAlign: 'center' }} className="body-14-medium">
        {tenantData?.copyright_notice}
      </div>
      <div className="body-14-medium">
        Contact:{' '}
        <a style={{ color: 'var(--ant-color-primary)' }} href={`mailto:${tenantData?.support_email}`}>
          {tenantData?.support_email}
        </a>
      </div>
    </div>
  );
};

export default CopyRight;
